export const getDataTableOverrides = theme => {
  return {
    MUIDataTable: {
      styleOverrides: {
        responsiveBase: {
          borderRadius: "8px"
        },
        responsiveScroll: {
          borderRadius: "8px"
        },
        root: {
          border: `1px solid ${theme.palette.secondary.dark}`,
          borderRadius: "8px",
          boxShadow: "0px 2px 6px -2px rgba(0, 0, 0, 0.06)!important",
          background: theme.palette.background.paper
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: 12,
          fontWeight: 400,
          letterSpacing: 0.4,
          background: theme.palette.background.elevation1,
          borderRight: `1px solid ${theme.palette.table.border}`,
          padding: "4px 8px",
          height: "42px"
        },
        footer: {
          left: 0,
          bottom: 0,
          padding: 8,
          position: "sticky"
        }
      }
    },
    MUIDataTableHeadCell: {
      styleOverrides: {
        fixedHeader: {
          background: theme.palette.background.default
        }
      }
    }
  };
};